import apiClient from './client';

export function fetchPublicProducts() {
  return apiClient.get('/products/public');
}

